import "../../style.css";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Col, Form, Row, InputGroup } from "react-bootstrap";
import ButtonCom from "../../../../components/button/button";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import DatePicker from "react-datepicker";
import { LuCalendarDays } from "react-icons/lu";
import { CiMenuKebab } from "react-icons/ci";
import { MdOutlineFileDownload } from "react-icons/md";
import { MdClear } from 'react-icons/md';
import { RxCross2 } from "react-icons/rx";
import { LiaRupeeSignSolid } from "react-icons/lia";
import TableSkeleton from "../../../../components/table/TableSkeleton.js";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { ToastContainer, toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { FiInfo } from "react-icons/fi";

import SalaryDetails from "../../../EmployeeManagement/SalaryDetails/SalaryDetails.js";
import AddCtc from "../AddCtc.js";

import {
  getCapitalizeWord,
  getInitials,
  getInitialColor,
  generateForm22Doc,
  csvDataWithNestedObject,
  downloadAsPdf,
  exportToExcel,
  downloadCSV,
  formattedRunPayrollSalarySlip,
  formatIndianAmountType
} from "../../../../services/commonServices.js";
import CustomPagination from "../../../../components/CustomPagination";

import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";

import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material";

import {
  getRunPayrollEmployeePath,
  calculateEarnedSalaryPath,
  savePaymentHistoryPath,
  saveFinalizePayrollPath,
  getPayrollModelListPath,
} from "../../../../services/config.js";
import {
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
  commonGetData,
} from "../../../../redux/slices/commonSlice.js";

import Widgets from "../../../../components/Widgets/index.js";

import { HasPermission } from "../../../../services/hasPermission.js";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const RunPayroll = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const commonStore = useSelector((state) => state.common);

  const [runPayrollList, setRunPayrollList] = useState([]);
  const [runPayrollListOne, setRunPayrollListOne] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [models, setModels] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [addCtc, setAddCtc] = useState({});
  const [addAllowance, setAddAllowance] = useState([]);
  const [addNewAllowance, setAddNewAllowance] = useState([]);
  const [salaryCtc, setSalaryCtc] = useState({});

  const [isActive, setIsActive] = useState(false);
  const [isAddCtcActive, setIsAddCtcActive] = useState(false);
  const [staffName, setStaffName] = useState(null);
  const [staffId, setStaffId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");

  const [state, setState] = useState({
    payrollMonth: "",
    branchId: "",
    shiftId: "",
    modelId: "",
  });

  const [startLeavingDate, setStartLeavingDate] = useState(null);
  const [endLeavingDate, setEndLeavingDate] = useState(null);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const [maxMonth, setMaxMonth] = useState("");

  const fetchModels = useCallback(() => {
    dispatch(commonGetData(getPayrollModelListPath + user.user_id));
  }, [user.user_id, dispatch]);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      payrollMonth: `${year}-${month}`,
    }));

    fetchModels();
    // Initialize data
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));

    // Trigger initial load
    getRunPayroll(`${year}-${month}`, "", "", "");
  }, []);

  const getRunPayroll = useCallback((payrollMonth, branchId, shiftId, modelId) => {
    if (payrollMonth) {
      const data = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          selectedDate: `${payrollMonth}-01`,
          branchId: branchId || "",
          shiftId: shiftId || "",
          modelId: modelId || "",
        },
      };
      dispatch(commonSaveDataOne(data));
    }
  }, [user.user_id, dispatch]);

  const handlePaymentHistory = (date) => {
    const data = {
      path: savePaymentHistoryPath,
      data: {
        userId: user.user_id,
        selectedDate: `${date}-01`,
        branchId: state.branchId || "",
        shiftId: state.shiftId || "",
        staffId: "",
        modelId: state.modelId || "",
      },
    };
    dispatch(commonSaveData(data));
  };

  const handelChange = ({ target: { name, value } }) => {
    const updatedState = {
      ...state,
      [name]: value,
    };

    setState(updatedState);

    // Always trigger API call with updated state
    getRunPayroll(
      name === "payrollMonth" ? value : updatedState.payrollMonth,
      name === "branchId" ? value : updatedState.branchId,
      name === "shiftId" ? value : updatedState.shiftId,
      name === "modelId" ? value : updatedState.modelId
    );

    // Also update payment history when month changes
    if (name === "payrollMonth") {
      handlePaymentHistory(value);
    }
  };

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }

    // Handle models data from commonGetData
    if (commonStore.commonGetSuccess && commonStore.commonGetData) {
      setModels(commonStore.commonGetData || []);
      dispatch(initCommonState());
    }

    // Handle run payroll data response
    if (commonStore.commonSuccessOne) {
      const staffDetails = commonStore.commonDataOne?.staffDetails || [];
      if (searchQuery !== "") {
        searchEmployees(searchQuery, staffDetails);
      } else {
        setRunPayrollList(staffDetails);
        setRunPayrollListOne(staffDetails);
      }
      dispatch(initCommonState());
    }

    // Handle other common states
    if (commonStore.commonSuccess || commonStore.commonError) {
      dispatch(initCommonState());
    }
  }, [branchState, departState, shiftState, commonStore]);

  const handleClickFromD1 = (id) => {
    document.getElementById(id).click();
  };

  const [selectedUsers, setSelectedUsers] = useState([]);

  const selectUser = (event, userId) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) =>
      isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId)
    );
  };

  const toggleSelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = runPayrollList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const isSelectAll =
    selectedUsers.length === runPayrollList.length && runPayrollList.length > 0;

  const HeaderCheckboxOnly = ({ isSelectAll, toggleSelectAll }) => (
    <input
      type="checkbox"
      checked={isSelectAll}
      onChange={toggleSelectAll}
      id="sel-all"
      className="colored-checkbox"
    />
  );
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const gridRef = useRef(null);

  const onSelectionChanged = useCallback(() => {
    const selectedNodes = gridRef.current.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRowsData(selectedData);
  }, []);

  const [isVerifyOrFinalize, setIsVerifyOrFinalize] = useState(false);

  const letsFinalizeSalary = () => {
    const array = selectedRowsData.map((item) => {
      return item.staffId;
    });

    const data = {
      path: saveFinalizePayrollPath,
      data: {
        userId: user.user_id,
        staffId: array.toString(),
        selectedDate: state.payrollMonth + "-01",
        payrollFinalize: "1",
      },
    };

    dispatch(commonSaveData(data));

    setIsVerifyOrFinalize(false);
    setSelectedRowsData([]);
    setIsFinalizePayroll(false);
  };

  const [isFinalizePayroll, setIsFinalizePayroll] = useState(false);

  const redirectToRunPayroll = (data) => {
    if (data.CostToCompany > 0) {
      navigate(
        `/run-payroll?user=${user.user_id}&staffName=${data.staffName}&staffId=${data.staffId}&month=${state.payrollMonth}`
      );
    } else {
      toast.error("Please enable CTS first.");
    }
  };

  // Function to format date to DD-MM format
  const formatDateToDDMM = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}`;
  };

  // Function to format full date to DD/MM/YYYY format
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Function to calculate days between two dates
  const calculateDaysBetween = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end dates
    return diffDays;
  };

  const columns = useMemo(
    () => [
      {
        headerName: "",
        field: "checkbox",

        checkboxSelection: (params) => params.data?.CostToCompany > 0,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: false,

        width: 40,
        suppressMenu: true,
        suppressSorting: true,
        pinned: "left",
      },
      {
        headerName: "SNo",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 60,
        pinned: "left",
      },

      {
        headerName: "Employee ID",
        field: "employeeId",
        pinned: "left",
        width: 120,
      },

      {
        headerName: "Name",
        field: "staffName",
        filter: true,
        pinned: "left",
        width: "350px",
        cellRenderer: (row) => {
          return (
            <span
              onClick={() => redirectToRunPayroll(row.data)}
              className="table-link d-flex align-items-center justify-content-start gap-2"
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(row.data.staffName),
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(row.data.staffName)}
              </div>
              {getCapitalizeWord(row.data.staffName)}
            </span>
          );
        },
      },
      {
        headerName: "Job title",
        field: "jobTitle",
        filter: true,
        cellRenderer: (row) => {
          return <span> {row.data.jobTitle ? row.data.jobTitle : "-"} </span>;
        },
      },
      {
        headerName: "Attendance Cycle",
        field: "attendanceCycle",
        width: "130px",
        filter: true,
        cellRenderer: (row) => {
          // Check if salaryCountDays exists and has cycleTypeValue
          if (row.data.salaryCountDays && row.data.salaryCountDays.cycleTypeValue) {
            const cycleType = row.data.salaryCountDays.cycleTypeValue;
            // Format the cycle type for display
            let displayText = cycleType;
            if (cycleType === "CalendarMonth") {
              displayText = "Calendar Month";
            } else if (cycleType === "FinancialYear") {
              displayText = "Financial Year";
            } else if (cycleType === "Custom") {
              displayText = "Custom Cycle";
            } else if (cycleType === "Weekly") {
              displayText = "Weekly";
            } else if (cycleType === "BiWeekly") {
              displayText = "Bi-Weekly";
            } else if (cycleType === "Monthly") {
              displayText = "Monthly";
            }
            return <span>{displayText}</span>;
          }
          return <span>-</span>;
        },
      },
      {
        headerName: "Payroll Finalized",
        field: "payrollFinalized",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
        width: "150",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {row.data.salaryCountDays
                ? row.data.salaryCountDays.finalizePayrollStaff == "1"
                  ? "Yes"
                  : "No"
                : "No"}
            </span>
          );
        },
      },
      {
        headerName: "CTC",
        field: "ctc",
        width: "100px",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span
              onClick={() => handleViewCtc(row.data)}
              style={{
                cursor: "pointer",
                color: row.data.CostToCompany > 0 ? "#3498db" : "#e74c3c",
              }}
            >
              {row.data.empStaffDetails != null &&
                row.data.empStaffDetails != [] ? (
                formatIndianAmountType(row.data.CostToCompany)
              ) : (
                <>
                  Not Set
                  <Tooltip
                    title="Looks like CTC isn't set yet. Add it now!"
                    placement="top"
                    slots={{
                      transition: Zoom,
                    }}
                    followCursor
                    arrow
                  >
                    <span>
                      <FiInfo
                        className="info-icon"
                        style={{ fontSize: "14px" }}
                      />
                    </span>
                  </Tooltip>
                </>
              )}
            </span>
          );
        },
      },
      {
        headerName: "Payable",
        field: "payable",
        width: "80px",
        filter: true,
        cellRenderer: (row) => {
          return <span> {formatIndianAmountType(parseFloat(row.data.payDaysCount).toFixed(2))} </span>;
        },
      },
      {
        headerName: "Total Salary",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "110px",
        filter: true,
        cellRenderer: (row) => {
          return <span> {formatIndianAmountType(row.data.netSalary)} </span>;
        },
      },
      {
        headerName: "Paid",
        field: "paid",
        width: "80px",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {" "}
              {row.data.salaryCountDays.paidAmount
                ? formatIndianAmountType(row.data.salaryCountDays.paidAmount)
                : "-"}{" "}
            </span>
          );
        },
      },
      {
        headerName: "Pending",
        field: "pending",
        width: "110px",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {" "}
              {row.data.salaryCountDays.paidAmount
                ? formatIndianAmountType(parseFloat(row.data.CostToCompany)) -
                formatIndianAmountType(parseFloat(row.data.salaryCountDays.paidAmount))
                : "-"}{" "}
            </span>
          );
        },
      },
      {
        headerName: "Slip Shared",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
        field: "slipShared",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span> {row.data.slipShared ? row.data.slipShared : "-"} </span>
          );
        },
      },
      {
        headerName: "Bank Verified",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
        field: "bankUPIVerified",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {row.data.bankUPIVerified ? row.data.bankUPIVerified : "No"}
            </span>
          );
        },
      },
    ],
    [state.payrollMonth]
  );

  const finalPayColumns = useMemo(
    () => [
      {
        headerName: "Employee ID",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.employeeId}</span>
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Name",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.staffName}</span>
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "CTC",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.CostToCompany}</span>
            </div>
          );
        },
        filter: true,
      },

      {
        headerName: "Payable",
        cellRenderer: (rowData) => {
          return (
            <div className="">
              <span>{rowData.data.netSalary}</span>
            </div>
          );
        },
        filter: true,
      },

      {
        headerName: "Paid",
        cellRenderer: (rowData) => {
          return (
            <div className="">
              <span>
                {rowData.data.salaryCountDays
                  ? rowData.data.salaryCountDays.paidAmount
                  : 0}
              </span>
            </div>
          );
        },
        filter: true,
      },

      {
        headerName: "Remaining",
        cellRenderer: (rowData) => {
          return (
            <div className="">
              <span>
                {parseFloat(rowData.data.netSalary).toFixed(2) -
                  (rowData.data.salaryCountDays
                    ? parseFloat(
                      rowData.data.salaryCountDays?.paidAmount
                    ).toFixed(2)
                    : 0)}
              </span>
            </div>
          );
        },
        filter: true,
      },
    ],
    []
  );

  const filterRecord = ({ target: { checked } }) => {
    if (checked) {
      const array = runPayrollListOne.filter((item) => item.status == "Active");
      setRunPayrollList(array);
    } else {
      setRunPayrollList(runPayrollListOne);
    }
  };


  const searchEmployees = (value, dataList) => {
    setSearchQuery(value);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.staffName.toLowerCase().includes(value.toLowerCase()) ||
        (v.employeeId && v.employeeId.toLowerCase().includes(value.toLowerCase()))
    );
    setRunPayrollList(filteredEmployees);
    setRunPayrollListOne(dataList)
  };

  const resetFilter = () => {
    setState((prev) => ({
      ...prev,
      branchId: "",
      shiftId: "",
      modelId: "",
    }));
    getRunPayroll(state.payrollMonth, "", "", "");
    setSearchQuery("");
    document.querySelector("#filterCheckbox").checked = false;
  };

  const toggleAddCtc = () => {
    setIsActive(false);
    setSalaryCtc({});
    localStorage.removeItem("ctc-added");
    setAddCtc({});
  };

  const [isRemove, setIsRemove] = useState(false);

  const toggleCtc = () => {
    setStaffId(null);
    setIsRemove(true);
    setIsAddCtcActive(false);
  };

  const handleViewCtc = (data) => {
    setStaffId(data.staffId);
    setStaffName(data.staffName);
    if (data.basicPay) {
      setAddCtc(data);
    }
    const allowanceArr = data.allowanceList?.filter(
      (item) => item.name != "Other Allowance"
    );
    setAddAllowance(allowanceArr);

    const newAllowanceArr = data.newAllowanceList?.filter(
      (item) => item.name != "Other Allowance"
    );
    setAddNewAllowance(newAllowanceArr);

    setIsActive(true);
  };

  const handleAddCtc = (data) => {
    setIsActive(false);
    setIsAddCtcActive(true);
  };

  const handleSaveSalary = () => {
    getRunPayroll(state.payrollMonth, state.branchId, state.shiftId, state.modelId);
    const salaryC = JSON.parse(localStorage.getItem("ctc-added")) || {};
    setSalaryCtc(salaryC);
    setIsAddCtcActive(false);
  };

  const hideSidebar = () => {
    if (isActive) {
      setIsActive(false);
      setAddCtc({});
    }
  };
  const [formType, setFormType] = useState("");

  const [isDownload, setIsDownload] = useState(false);
  const handleDownloadOpen = () => {
    setIsDownload(true);
  };
  const handleDownloadClose = () => {
    setIsDownload(false);
  };
  const handleDownloadAction = (formType) => {
    setFormType(formType);
    handleDownloadOpen();
  };

  const [fileFormat, setFileFormat] = useState("");

  const downloadFileInFormat = () => {
    if (fileFormat == "csv") {
      downloadCSV(
        formattedRunPayrollSalarySlip(runPayrollList),
        state.payrollMonth
      );
    } else if (fileFormat == "excel") {
      exportToExcel(
        formattedRunPayrollSalarySlip(runPayrollList),
        "run-payroll",
        `Payroll_Sheet_${state.payrollMonth}`
      );
    } else {
    }
    handleDownloadClose();
  };

  const clearFilter = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const defaultMonth = `${year}-${month}`;

    setSearchQuery("")
    setState({
      payrollMonth: defaultMonth,
      branchId: "",
      shiftId: "",
      departmentId: "",
      modelId: "",
    })
    getRunPayroll(defaultMonth, "", "", "");
  }

  return (
    <div
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "calc(100vh-76px)",
        zIndex: "1",
      }}
      className="mt-2"
    >
      <Widgets
        body={
          <Row>
            <Col sm="12">
              <div
                className="d-flex align-items-center justify-content-start gap-3 px-3"
                style={{ marginTop: "-30px" }}
              >
                <Form.Group>
                  <Form.Control
                    name="searchQuery"
                    value={searchQuery}
                    onChange={(e) => searchEmployees(e.target.value, runPayrollListOne)}
                    placeholder="Search"
                    style={{ width: "200px" }}
                    className="universal-input"
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Control
                    type="month"
                    name="payrollMonth"
                    value={state.payrollMonth}
                    max={maxMonth}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    name="modelId"
                    value={state.modelId}
                    onChange={handelChange}
                    className="universal-input"
                    style={{ width: "220px" }}
                  >
                    <option value="">{state.modelId ? "All Models" : "Select Model"}</option>
                    {models.map((row, idx) => {
                      // Get model name
                      const modelName = row.payrollModelName || row.modelName || row.name || `Model ${idx + 1}`;

                      // Get attendance cycle string
                      const attendanceCycle = row.attendanceCycle || row.cycleType || '';

                      let displayText = modelName;

                      // If attendanceCycle contains pipe separator, extract the date range
                      if (attendanceCycle && attendanceCycle.includes('|')) {
                        const parts = attendanceCycle.split('|');
                        if (parts.length >= 2) {
                          // parts[0] = cycle type (CalendarMonth, FixedDate, CustomDate)
                          // parts[1] = date range (e.g., "01-31", "02-01")
                          const dateRange = parts[1];

                          // Format date range to ensure 2 digits
                          if (dateRange.includes('-')) {
                            const [startDay, endDay] = dateRange.split('-');
                            const formattedStart = startDay.padStart(2, '0');
                            const formattedEnd = endDay.padStart(2, '0');
                            const formattedDateRange = `${formattedStart}-${formattedEnd}`;

                            displayText = `${modelName} (${formattedDateRange})`;
                          }
                        }
                      }
                      // Also check if payrollModelName itself contains the date info
                      else if (modelName && modelName.includes('|')) {
                        const parts = modelName.split('|');
                        if (parts.length >= 3) {
                          // Format: "Model Name | CycleType | DateRange"
                          const cleanModelName = parts[0].trim();
                          const dateRange = parts[2].trim();

                          if (dateRange.includes('-')) {
                            const [startDay, endDay] = dateRange.split('-');
                            const formattedStart = startDay.padStart(2, '0');
                            const formattedEnd = endDay.padStart(2, '0');
                            const formattedDateRange = `${formattedStart}-${formattedEnd}`;

                            displayText = `${cleanModelName} (${formattedDateRange})`;
                          } else {
                            displayText = cleanModelName;
                          }
                        }
                      }

                      return (
                        <option
                          value={row.payrollModelId || row.id || idx}
                          key={idx}
                          title={displayText}
                        >
                          {displayText}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    name="branchId"
                    value={state.branchId}
                    onChange={handelChange}
                    className="universal-input"
                  >
                    <option value="">{state.branchId ? "All Branches" : "Select Branch"}</option>
                    {branch.map((row, idx) => {
                      return (
                        <option value={row.branchId} key={idx}>
                          {row.branch_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group>
                  <Form.Select
                    name="shiftId"
                    value={state.shiftId}
                    onChange={handelChange}
                    className="universal-input"
                    style={{ width: "180px" }}
                  >
                    <option value="">{state.shiftId ? "All Shift" : "Select Shift"}</option>
                    {shift.map((row, idx) => {
                      return (
                        <option value={row.shiftId} key={idx}>
                          {row.shiftName}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group>
                  {
                    (
                      searchQuery ||
                      state.payrollMonth != `${year_1}-${month_1}` ||
                      state.shiftId ||
                      state.departmentId ||
                      state.branchId ||
                      state.modelId) && <button type="button" className="clear" onClick={clearFilter}>
                      <MdClear /> Clear
                    </button>
                  }
                </Form.Group>

                {selectedRowsData.length > 0 ? (
                  <Form.Group>
                    <ButtonCom
                      class_name="p_btn universal-input color-gray"
                      text="Finalize Salary"
                      width="130px"
                      type="button"
                      url_or_onclick={() => setIsFinalizePayroll(true)}
                      icon={null}
                    />
                  </Form.Group>
                ) : null}
              </div>

              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 240px)",
                  width: "100%",
                  padding: "10px 20px",
                  paddingRight: "40px",
                }}
                onClick={hideSidebar}
              >
                {commonStore.commonLoadingOne ? (
                  <TableSkeleton />
                ) : (
                  <AgGridReact
                    rowData={Array.isArray(runPayrollList) ? runPayrollList : []}
                    columnDefs={columns}
                    omLayout="autoHeight"
                    pagination={true}
                    paginationPageSize={paginationPageSize}
                    onGridReady={onGridReady}
                    ref={gridRef}
                    rowSelection="multiple"
                    onSelectionChanged={onSelectionChanged}
                    suppressRowClickSelection={true}
                    isRowSelectable={(rowNode) =>
                      rowNode.data?.CostToCompany > 0
                    }
                  />
                )}
              </div>

              <div className="d-flex align-items-center justify-content-between custom-pagination px-3">
                {gridApi && <CustomPagination gridApi={gridApi} />}
                <div className="d-flex align-items-center justify-content-start gap-2">
                  {runPayrollList.length > 0
                    ? HasPermission("Run Payroll", "export") && (
                      <>
                        <ButtonCom
                          class_name="p_btn universal-btn height_35"
                          text="Download Salary Sheet"
                          width="auto"
                          type="button"
                          url_or_onclick={handleDownloadOpen}
                          icon={<MdOutlineFileDownload />}
                        />

                        {/* <ButtonCom
                          class_name="p_btn universal-btn height_35"
                          text="Import Earnings Salary"
                          width="auto"
                          type="button"
                          url_or_onclick={null}
                          icon={<MdOutlineFileDownload />}
                        />

                        <ButtonCom
                          class_name="p_btn universal-btn height_35"
                          text="Import Deductions"
                          width="auto"
                          type="button"
                          url_or_onclick={null}
                          icon={<MdOutlineFileDownload />}
                        /> */}
                      </>
                    )
                    : null}
                </div>
              </div>
            </Col>
          </Row>
        }
      />

      <Dialog
        open={isDownload}
        maxWidth="xs"
        fullWidth
        onClose={handleDownloadClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleDownloadClose}>
              X
            </span>
            <span className="title">File Format</span>
          </div>
          <button className="universal-btn" onClick={downloadFileInFormat}>
            Download
          </button>
        </DialogTitle>
        <DialogContent>
          <Form.Group>
            <Form.Label className="color-white mt-3">
              Select a file format to download
            </Form.Label>
            <Form.Select
              onChange={(e) => setFileFormat(e.target.value)}
              className="universal-input-one"
            >
              <option value={""}>Select File Format</option>
              <option value={"excel"}> Excel</option>
              <option value={"csv"}> CSV</option>
            </Form.Select>
          </Form.Group>
        </DialogContent>
      </Dialog>

      <div className={isActive ? "date-hamberger active" : "date-hamberger"}>
        <div className="date-hamberger-header">
          <div>
            <RxCross2
              className="icon border-gray"
              style={{ fontSize: "15px", marginTop: "2px", color: "white" }}
              onClick={toggleAddCtc}
            />

            <span style={{ marginLeft: "10px", color: "white" }}>
              {getCapitalizeWord(staffName)}
            </span>
          </div>
        </div>
        <div className="date-hamberger-body">
          {Object.keys(addCtc).length > 0 ? (
            <div className="ctc-content">
              <div className="ctc-content-title">
                <span style={{ color: "#000" }}>Gross Amount</span>
                <span style={{ color: "#000" }}>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0
                    ? addCtc.empStaffDetails
                      ? addCtc.empStaffDetails.grossAmount
                      : 0
                    : 0}
                </span>
              </div>

              <div className="ctc-content-title mt-3">
                <span style={{ color: "#000" }}>Earnings</span>
              </div>
              <div className="ctc-content-subtitle">
                <span>BASIC</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.basicPay : 0}
                </span>
              </div>
              {addAllowance?.length > 0 &&
                addAllowance
                  .filter((row, idx) => row.name == "Dearness Allowance")
                  .map((row, idx) => {
                    return (
                      <div className="ctc-content-subtitle" key={idx}>
                        <span>{row.name}</span>
                        <span>
                          <LiaRupeeSignSolid /> {row.monthlyAmount}
                        </span>
                      </div>
                    );
                  })}

              <div className="ctc-content-subtitle">
                <span>HRA</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.hraPay : 0}
                </span>
              </div>

              {addAllowance?.length > 0 &&
                addAllowance
                  .filter((row, idx) => row.name != "Dearness Allowance")
                  .map((row, idx) => {
                    return (
                      <div className="ctc-content-subtitle" key={idx}>
                        <span>{row.name}</span>
                        <span>
                          <LiaRupeeSignSolid /> {row.monthlyAmount}
                        </span>
                      </div>
                    );
                  })}

              <div className="ctc-content-subtitle">
                <span>Other Allowance</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.otherAllowance : 0}
                </span>
              </div>

              <div className="ctc-content-title mt-3">
                <span style={{ color: "#000" }}>Employer Contribution</span>
              </div>
              <div className="ctc-content-subtitle">
                <span>Employer PF</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployerPF : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span>Employer ESI</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployerESI : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span>Employer LWF</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployerLWF : 0}
                </span>
              </div>
              <div className="ctc-content-subtitle">
                <span>PF EDLI & Admin Charges</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0
                    ? parseFloat(addCtc.totalAdminCharges) +
                    parseFloat(addCtc.totalEDLICharges)
                    : 0}
                </span>
              </div>

              {addNewAllowance?.length > 0 &&
                addNewAllowance.map((row, idx) => {
                  return (
                    <div className="ctc-content-subtitle" key={idx}>
                      <span>{row.name}</span>
                      <span>
                        <LiaRupeeSignSolid /> {row.monthlyAmount}
                      </span>
                    </div>
                  );
                })}

              <div className="ctc-content-title mt-3">
                <span style={{ color: "#000" }}>Deductions</span>
              </div>
              <div className="ctc-content-subtitle">
                <span>Employee PF</span>{" "}
                <span>
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployeePF : 0}{" "}
                  {Object.keys(addCtc).length > 0
                    ? addCtc.totalEmployeePF == "1800"
                      ? "LIMIT"
                      : ""
                    : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span>Employee ESI</span>{" "}
                <span>
                  {" "}
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployeeESI : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span>Employee LWF</span>{" "}
                <span>
                  {" "}
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0 ? addCtc.totalEmployeeLWF : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span>Professional Tax</span>{" "}
                <span>
                  {" "}
                  <LiaRupeeSignSolid />{" "}
                  {Object.keys(addCtc).length > 0
                    ? addCtc.totalProfessionalTax
                    : 0}
                </span>
              </div>
            </div>
          ) : (
            <div className="ctc_not_added">
              <span style={{ textWrap: "nowrap", marginRight: "60px" }}>
                CTC not added
              </span>

              {HasPermission("Run Payroll", "create") && (
                <ButtonCom
                  type="button"
                  class_name={"p_btn universal-input"}
                  text={"+ Add CTC"}
                  url_or_onclick={handleAddCtc}
                  icon={null}
                  width={""}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <div
        className={
          isAddCtcActive
            ? "right-slider-menubar active"
            : "right-slider-menubar"
        }
      >
        <div className="right-slider-menubar-header">
          <div className="header-content">
            <RxCross2
              className="icon color-white, border-gray"
              style={{ color: "#fff" }}
              onClick={toggleCtc}
            />

            <span style={{ marginLeft: "10px", color: "#fff" }}>
              {staffName}
            </span>
          </div>
        </div>

        <div className="right-slider-menubar-body">
          {staffId && (
            <AddCtc
              staffId={staffId}
              staffName={staffName}
              handleSaveSalary={handleSaveSalary}
              isRemove={isRemove}
            />
          )}
        </div>
      </div>

      <div
        className={
          isFinalizePayroll
            ? "extra-size-slider-popup active"
            : "extra-size-slider-popup"
        }
      >
        <div className="d-flex align-items-center justify-content-start gap-2 py-2 ">
          <RxCross2
            className="icon"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              marginTop: "2px",
              color: "#fff",
            }}
            onClick={() => setIsFinalizePayroll(false)}
          />
          <span style={{ marginLeft: "10px", color: "#fff" }}>
            {getCapitalizeWord(staffName)}
          </span>
        </div>

        <div>
          <div className="mt-3">
            <hr />
            <div className="d-flex align-items-center justify-content-between px-5">
              <h4>Verify Attendance</h4>
              {isVerifyOrFinalize ? (
                <ButtonCom
                  type={"button"}
                  text="Finalize Salary"
                  class_name={"p_btn universal-input-one border-gray"}
                  url_or_onclick={() => letsFinalizeSalary()}
                  icon={null}
                  width="150px"
                />
              ) : (
                <ButtonCom
                  type={"button"}
                  text="Verify Salary"
                  class_name={"p_btn universal-input-one border-gray"}
                  url_or_onclick={() => setIsVerifyOrFinalize(true)}
                  icon={null}
                  width="150px"
                />
              )}
            </div>
            <hr />

            {isVerifyOrFinalize ? (
              <>
                <div className="d-flex align-items-center justify-content-between px-5 mt-3 mb-3">
                  <span className="finalize-header pure-dark-bg-color p-1">
                    Emp ID
                  </span>
                  <span className="finalize-header pure-dark-bg-color p-1">
                    Name
                  </span>
                  <span className="finalize-header pure-dark-bg-color p-1">
                    CTC
                  </span>
                  <span className="finalize-header pure-dark-bg-color p-1">
                    Payable
                  </span>
                  <span className="finalize-header pure-dark-bg-color p-1">
                    Paid
                  </span>
                  <span className="finalize-header pure-dark-bg-color p-1">
                    Remaining
                  </span>
                </div>
                {selectedRowsData?.map((item, idx) => {
                  return (
                    <div className="d-flex flex-column gap-2" key={idx}>
                      <div className="d-flex align-items-center justify-content-between px-5">
                        <span className="width-200 p-1">{item.employeeId}</span>
                        <span className="width-200 p-1">{item.staffName}</span>
                        <span className="width-200 p-1">
                          {item.CostToCompany}
                        </span>
                        <span className="width-200 p-1">{item.netSalary}</span>
                        <span className="width-200 p-1">
                          {item.salaryCountDays?.paidAmount}
                        </span>
                        <span className="width-200 p-1">
                          {parseFloat(item.netSalary).toFixed(2) -
                            parseFloat(item.salaryCountDays.paidAmount).toFixed(
                              2
                            )}
                        </span>
                      </div>
                      <div className="px-5 mt-1 mb-2">
                        <Row>
                          <Col sm="3">
                            <div className="green-box width-100-percent height-300">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Earnings</span>
                                <span className="font-12">12683</span>
                              </div>
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Basic</span>
                                <span className="font-12">{item.basicPay}</span>
                              </div>
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">HRA</span>
                                <span className="font-12">{item.hraPay}</span>
                              </div>
                              {item.allowanceList?.map((row, id) => {
                                return (
                                  <div
                                    className="d-flex align-items-center justify-content-between mb-2"
                                    key={id}
                                  >
                                    <span className="font-12">{row.name}</span>
                                    <span className="font-12">
                                      {row.monthlyAmount}
                                    </span>
                                  </div>
                                );
                              })}

                              {item.newAllowanceList?.map((row1, id) => {
                                return (
                                  <div
                                    className="d-flex align-items-center justify-content-between mb-2"
                                    key={id}
                                  >
                                    <span className="font-12">{row1.name}</span>
                                    <span className="font-12">
                                      {row1.monthlyAmount}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </Col>
                          <Col sm="3">
                            <div className="lightgray-box width-100-percent height-300">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employer PF</span>
                                <span className="font-12">
                                  {item.totalEmployerPF}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employer ESI</span>
                                <span className="font-12">
                                  {item.totalEmployerESI}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  PF EDLI & Admin Charges
                                </span>
                                <span className="font-12">
                                  {parseFloat(item.totalEDLICharges) +
                                    parseFloat(item.totalAdminCharges)}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Labour Welfare Fund
                                </span>
                                <span className="font-12">
                                  {item.totalEmployerLWF}
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col sm="3">
                            <div className="gray-box width-100-percent height-300">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Compliance Deductions
                                </span>
                                <span className="font-12">
                                  {parseFloat(item.totalEmployerPF) +
                                    parseFloat(item.totalEmployerESI) +
                                    parseFloat(item.totalEmployeePF) +
                                    parseFloat(item.totalEmployeeESI) +
                                    parseFloat(item.totalProfessionalTax) +
                                    parseFloat(item.totalAdminCharges) +
                                    parseFloat(item.totalEDLICharges) +
                                    parseFloat(item.totalEmployeeLWF) +
                                    parseFloat(item.totalEmployerLWF)}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employer PF</span>
                                <span className="font-12">
                                  {item.totalEmployerPF}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employer ESI</span>
                                <span className="font-12">
                                  {item.totalEmployerESI}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employee PF</span>
                                <span className="font-12">
                                  {item.totalEmployeePF}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">Employee ESI</span>
                                <span className="font-12">
                                  {item.totalEmployeeESI}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Professional Tax
                                </span>
                                <span className="font-12">
                                  {item.totalProfessionalTax}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  PF EDLI & Admin Charges
                                </span>
                                <span className="font-12">
                                  {parseFloat(item.totalEDLICharges) +
                                    parseFloat(item.totalAdminCharges)}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Employee Labour Welfare Fund
                                </span>
                                <span className="font-12">
                                  {item.totalEmployeeLWF}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Employer Labour Welfare Fund
                                </span>
                                <span className="font-12">
                                  {item.totalEmployerLWF}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">TDS</span>
                                <span className="font-12">0.00</span>
                              </div>
                            </div>
                          </Col>
                          <Col sm="3">
                            <div className="orange-box width-100-percent height-300">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Compliance Deductions
                                </span>
                                <span className="font-12">
                                  {item.salaryCountDays.length != 0
                                    ? parseFloat(
                                      item.salaryCountDays.earlyFinePayAmount
                                    ) +
                                    parseFloat(
                                      item.salaryCountDays.lateFinePayAmount
                                    ) +
                                    +parseFloat(
                                      item.salaryCountDays
                                        .otherDeductionsAmount
                                    )
                                    : 0}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Early Fine Pay Amount
                                </span>
                                <span className="font-12">
                                  {item.salaryCountDays.length != 0
                                    ? item.salaryCountDays.earlyFinePayAmount
                                    : 0}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Late Fine Pay Amount
                                </span>
                                <span className="font-12">
                                  {item.salaryCountDays.length != 0
                                    ? item.salaryCountDays.lateFinePayAmount
                                    : 0}
                                </span>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-12">
                                  Other Deductions Amount
                                </span>
                                <span className="font-12">
                                  {item.salaryCountDays.length != 0
                                    ? item.salaryCountDays.otherDeductionsAmount
                                    : 0}
                                </span>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <hr />
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 220px)",
                    width: "100%",
                    padding: "10px 20px",
                  }}
                >
                  <AgGridReact
                    rowData={
                      Array.isArray(selectedRowsData) ? selectedRowsData : []
                    }
                    columnDefs={finalPayColumns}
                    omLayout="autoHeight"
                    onGridReady={onGridReady}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                </div>
              </>
            )}

            <div className="d-flex align-items-center justify-content-end mt-3 mb-4">
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default RunPayroll;